<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false" offset-y left>
    <template #activator="{ }">
      <v-icon
      color="primary"
      class="mr-1"
      id="decided-filter-activator"
      @click="menuOpen = !menuOpen">
        mdi-filter
      </v-icon>
    </template>
    <v-card width="520px" id="decided-filter-menu">
      <v-card-title class="primary white--text">
        {{ $t('decidedFilter') }}
      </v-card-title>
      <v-card-text class="pt-5 pb-2">
        <v-row dense>
          <v-col cols="12" class="mb-4">
            <v-select
            :items="allTeams"
            :label="$t('team')"
            v-model="filterBuilder.selectedTeams"
            :loading="teamsLoading"
            :menu-props="{ offsetY: true, maxHeight: 240 }"
            prepend-inner-icon="mdi-account-group"
            dense
            hide-details
            multiple
            chips
            deletable-chips
            return-object
            item-text="name"/>
          </v-col>
          <v-col cols="12" class="mb-4">
            <v-select
            :items="allMitigationGroups"
            :label="$t('mitigationGroups')"
            v-model="filterBuilder.selectedMitigationGroups"
            :loading="mitigationGroupsLoading"
            :menu-props="{ offsetY: true, maxHeight: 200 }"
            prepend-inner-icon="mdi-square-rounded"
            dense
            hide-details
            multiple
            chips
            deletable-chips
            return-object
            item-text="name"/>
          </v-col>
          <v-col cols="6">
            <v-select
            :items="presenceOptions"
            :label="$t('habitatRiskPresence')"
            v-model="filterBuilder.riskPresence"
            :menu-props="{ offsetY: true }"
            dense
            hide-details/>
          </v-col>
          <v-col cols="6">
            <v-select
            :items="statusOptions"
            :label="$t('status')"
            v-model="filterBuilder.status"
            :menu-props="{ offsetY: true }"
            dense
            hide-details/>
          </v-col>
        </v-row>
        <div class="dd-eyebrow mt-6">{{ $t('resolvedBetween') }}</div>
        <v-row dense>
          <v-col cols="12" sm="6">
            <DatePicker
            v-if="menuOpen"
            :dateLabel="$t('startDate')"
            :startDate="filterBuilder.resolvedFrom"
            clearable
            @date-picked="(date) => { filterBuilder.resolvedFrom = date }"/>
          </v-col>
          <v-col cols="12" sm="6">
            <DatePicker
            v-if="menuOpen"
            :dateLabel="$t('endDate')"
            :startDate="filterBuilder.resolvedTo"
            clearable
            menuLeft
            @date-picked="(date) => { filterBuilder.resolvedTo = date }"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-btn color="primary" outlined @click="resetFilter" id="decided-filter-reset">
          {{ $t('reset') }}
        </v-btn>
        <v-spacer/>
        <v-btn color="primary" id="decided-filter-apply" :disabled="!changed" @click="emitFilter">
          {{ $t('apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DueDiligenceApprovalStatus } from '@/utils/Enumerations.js'
import { emptyDecidedFilter, riskPresenceFilterOptions } from '@/utils/dueDiligence/presentation.js'
import { cloneDeep } from 'lodash'

export default {
  name: 'DecidedApprovalsFilter',

  components: {
    DatePicker: () => import('@/components/helper/DatePicker.vue')
  },

  props: {
    filter: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    menuOpen: false,
    filterBuilder: emptyDecidedFilter()
  }),

  computed: {
    ...mapGetters('team', ['allTeams', 'teamsLoading']),
    ...mapGetters('mitigation-group', ['allMitigationGroups', 'mitigationGroupsLoading']),

    presenceOptions () {
      return riskPresenceFilterOptions()
    },

    statusOptions () {
      return [
        { text: this.$t('any'), value: null },
        { text: this.$t('approved'), value: DueDiligenceApprovalStatus.Approved.value },
        { text: this.$t('rejected'), value: DueDiligenceApprovalStatus.Returned.value }
      ]
    },

    changed () {
      return JSON.stringify(this.filterBuilder) !== JSON.stringify(this.filter)
    }
  },

  watch: {
    menuOpen (isOpen) {
      if (isOpen) this.refresh()
      this.filterBuilder = cloneDeep(this.filter)
    }
  },

  methods: {
    ...mapActions('team', ['fetchTeams']),
    ...mapActions('mitigation-group', ['fetchMitigationGroups']),

    async refresh () {
      await Promise.all([this.fetchTeams(), this.fetchMitigationGroups()])
    },

    resetFilter () {
      this.filterBuilder = emptyDecidedFilter()
      this.emitFilter()
    },

    emitFilter () {
      this.$emit('filter-applied', cloneDeep(this.filterBuilder))
      this.menuOpen = false
    }
  }
}
</script>
